import React from "react";
import LandingHeader from "../components/layout/LandingHeader";
import LandingFooter from "../components/layout/LandingFooter";
import WhatsAppButton from "../components/common/WhatsAppButton";
import { Button } from "../components/ui";
import { Link } from "react-router";
import {
  Zap,
  Shield,
  QrCode,
  MapPin,
  Calendar,
  Check,
  Clock,
  Compass,
  Star,
  ShoppingBag,
  MessageSquare,
  CheckCircle2,
  List,
  Wallet,
  ArrowRight,
} from "lucide-react";

function ParaAtletas() {
  const heroImg = require("../statics/img/MERO-ATLETAS.png");

  return (
    <div className="min-h-screen flex flex-col bg-urb-dark text-slate-100 selection:bg-urb-primary selection:text-black">
      <LandingHeader />

      <main className="flex-1">
        {/* Hero Section Banner */}
        <section className="w-full relative overflow-hidden flex items-center py-10 md:py-16 mb-6 min-h-[22rem] md:min-h-[26rem]">
          {/* Background Banner Image */}
          <img
            src={heroImg}
            alt="URBRACE Banner Atletas"
            className="absolute top-0 right-0 h-full w-full z-0 object-cover object-center"
          />

          {/* Dark Gradient Overlay */}
          <div className="absolute top-0 left-0 h-full w-full z-10 bg-gradient-to-r from-[#0b0c0e]/95 via-[#0b0c0e]/80 to-[#0b0c0e]/45" />

          {/* Content over Banner */}
          <div className="max-w-7xl w-full mx-auto px-4 md:px-8 relative z-20">
            <div className="max-w-2xl text-left flex flex-col gap-3">
              <span className="text-xs md:text-sm font-bold tracking-widest uppercase text-urb-primary">
                FEITO PARA QUEM VIVE A CORRIDA
              </span>
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black m-0 leading-none tracking-tight uppercase">
                <span className="block mt-1 text-urb-primary drop-shadow-[0_0_12px_rgba(138,230,0,0.3)]">
                  PARA ATLETAS.
                </span>
              </h1>
              <p className="text-slate-300 text-xs sm:text-base m-0 leading-relaxed mt-2 max-w-xl">
                Encontre provas, faça sua inscrição, acompanhe sua participação e
                retire seu kit com praticidade. Tudo de forma simples, segura e
                organizada.
              </p>

              {/* Feature Badges */}
              <div className="flex flex-wrap gap-3 mt-4">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-900/80 border border-slate-700/80 text-xs text-white">
                  <Zap className="w-3.5 h-3.5 text-urb-primary" />
                  <span>Inscrição rápida</span>
                </div>
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-900/80 border border-slate-700/80 text-xs text-white">
                  <Shield className="w-3.5 h-3.5 text-urb-primary" />
                  <span>Pagamento seguro</span>
                </div>
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-900/80 border border-slate-700/80 text-xs text-white">
                  <QrCode className="w-3.5 h-3.5 text-urb-primary" />
                  <span>QR Code para retirada</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Timeline Process + Essential Box Container */}
        <section className="py-14 px-4 md:px-8 border-y border-urb-border bg-slate-950/40">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col items-center text-center mb-10">
              <h2 className="text-3xl md:text-4xl font-black m-0 text-white">
                PASSO A PASSO DA{" "}
                <span className="text-urb-primary">SUA CORRIDA</span>
              </h2>
              <p className="text-sm text-slate-400 mt-2 m-0 max-w-lg">
                Tudo o que você precisa saber desde a escolha da prova até o
                grande dia do treino!
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
              {/* Main Steps Timeline (6 Steps) */}
              <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {/* Step 1 */}
                <div className="flex flex-col items-center text-center gap-3 p-2">
                  <div className="flex flex-col items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-urb-primary/10 border border-urb-primary/40 text-urb-primary font-black text-sm flex items-center justify-center">
                      1
                    </div>
                    <div>
                      <h4 className="text-white font-bold text-xs m-0">
                        ENCONTRE SUA CORRIDA
                      </h4>
                      <span className="text-[10px] text-slate-400 block mt-0.5">
                        Descubra provas incríveis perto de você.
                      </span>
                    </div>
                  </div>
                  <div className="bg-slate-950/80 border border-slate-800 rounded-xl p-3 flex flex-col items-center text-center gap-2 w-full">
                    <span className="font-extrabold text-xs text-urb-primary uppercase">
                      URB NIGHT RUN
                    </span>
                    <div className="text-[10px] text-slate-300 flex items-center justify-center gap-1">
                      <MapPin className="w-3 h-3 text-urb-primary" />
                      <span>Macapá - Amapá</span>
                    </div>
                    <div className="flex justify-center gap-1 flex-wrap mt-0.5">
                      <span className="text-[9px] px-2 py-0.5 rounded bg-slate-900 text-white border border-slate-700">
                        10K
                      </span>
                      <span className="text-[9px] px-2 py-0.5 rounded bg-slate-900 text-white border border-slate-700">
                        5K
                      </span>
                      <span className="text-[9px] px-2 py-0.5 rounded bg-slate-900 text-white border border-slate-700">
                        KIDS
                      </span>
                    </div>
                    <span className="text-[10px] text-slate-400 mt-1 flex items-center gap-1">
                      <Calendar className="w-3 h-3 text-urb-primary" />
                      12/07/2025
                    </span>
                  </div>
                </div>

                {/* Step 2 */}
                <div className="flex flex-col items-center text-center gap-3 p-2">
                  <div className="flex flex-col items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-urb-primary/10 border border-urb-primary/40 text-urb-primary font-black text-sm flex items-center justify-center">
                      2
                    </div>
                    <div>
                      <h4 className="text-white font-bold text-xs m-0">
                        FAÇA SUA INSCRIÇÃO
                      </h4>
                      <span className="text-[10px] text-slate-400 block mt-0.5">
                        Escolha a prova e preencha seus dados.
                      </span>
                    </div>
                  </div>
                  <div className="bg-slate-950/80 border border-slate-800 rounded-xl p-3 flex flex-col items-center text-center gap-2 w-full">
                    <span className="font-bold text-xs text-white uppercase">
                      INSCRIÇÃO
                    </span>
                    <div className="flex items-center justify-between my-1 px-1 w-full">
                      <div className="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold bg-urb-primary text-black">
                        1
                      </div>
                      <div className="h-0.5 flex-1 mx-1 bg-urb-primary" />
                      <div className="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold bg-urb-primary text-black">
                        2
                      </div>
                      <div className="h-0.5 flex-1 mx-1 bg-slate-700" />
                      <div className="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold bg-slate-800 text-slate-400 border border-slate-700">
                        3
                      </div>
                    </div>
                    <Button variant="primary" size="sm" className="w-full text-[10px] font-bold py-1 mt-1 uppercase">
                      Finalizar inscrição
                    </Button>
                  </div>
                </div>

                {/* Step 3 */}
                <div className="flex flex-col items-center text-center gap-3 p-2">
                  <div className="flex flex-col items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-urb-primary/10 border border-urb-primary/40 text-urb-primary font-black text-sm flex items-center justify-center">
                      3
                    </div>
                    <div>
                      <h4 className="text-white font-bold text-xs m-0">
                        REALIZE O PAGAMENTO
                      </h4>
                      <span className="text-[10px] text-slate-400 block mt-0.5">
                        Pague com segurança e confirme sua vaga.
                      </span>
                    </div>
                  </div>
                  <div className="bg-slate-950/80 border border-slate-800 rounded-xl p-3 flex flex-col gap-1.5 text-center items-center py-3 w-full">
                    <div className="w-7 h-7 rounded-full flex items-center justify-center bg-emerald-950/80 text-urb-primary border border-emerald-500/40 mb-0.5">
                      <Check className="w-4 h-4 stroke-[3]" />
                    </div>
                    <span className="text-[9px] font-bold text-white uppercase tracking-wider">
                      PAGAMENTO CONFIRMADO
                    </span>
                    <span className="text-[10px] text-slate-400">Total pago</span>
                    <span className="text-sm font-black text-white">R$ 159,90</span>
                  </div>
                </div>

                {/* Step 4 */}
                <div className="flex flex-col items-center text-center gap-3 p-2">
                  <div className="flex flex-col items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-urb-primary/10 border border-urb-primary/40 text-urb-primary font-black text-sm flex items-center justify-center">
                      4
                    </div>
                    <div>
                      <h4 className="text-white font-bold text-xs m-0">
                        ACOMPANHE O EVENTO
                      </h4>
                      <span className="text-[10px] text-slate-400 block mt-0.5">
                        Fique por dentro de todas as informações.
                      </span>
                    </div>
                  </div>
                  <div className="bg-slate-950/80 border border-slate-800 rounded-xl p-3 flex flex-col gap-2 text-center items-center w-full">
                    <span className="text-[9px] font-bold text-slate-400 tracking-wider">
                      CONTAGEM REGRESSIVA
                    </span>
                    <div className="flex justify-center gap-1.5 my-0.5">
                      <div className="bg-slate-900 p-1 rounded border border-slate-800 text-center w-10">
                        <span className="text-xs font-bold text-white block">32</span>
                        <span className="text-[8px] text-slate-400">DIAS</span>
                      </div>
                      <div className="bg-slate-900 p-1 rounded border border-slate-800 text-center w-10">
                        <span className="text-xs font-bold text-white block">08</span>
                        <span className="text-[8px] text-slate-400">HORAS</span>
                      </div>
                      <div className="bg-slate-900 p-1 rounded border border-slate-800 text-center w-10">
                        <span className="text-xs font-bold text-white block">45</span>
                        <span className="text-[8px] text-slate-400">MIN</span>
                      </div>
                    </div>
                    <span className="text-[9px] text-urb-primary hover:underline cursor-pointer">
                      Ver informações do evento
                    </span>
                  </div>
                </div>

                {/* Step 5 */}
                <div className="flex flex-col items-center text-center gap-3 p-2">
                  <div className="flex flex-col items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-urb-primary/10 border border-urb-primary/40 text-urb-primary font-black text-sm flex items-center justify-center">
                      5
                    </div>
                    <div>
                      <h4 className="text-white font-bold text-xs m-0">
                        RETIRE SEU KIT
                      </h4>
                      <span className="text-[10px] text-slate-400 block mt-0.5">
                        Retire seu kit com facilidade usando o QR Code.
                      </span>
                    </div>
                  </div>
                  <div className="bg-slate-950/80 border border-slate-800 rounded-xl p-3 flex flex-col items-center text-center gap-1.5 w-full">
                    <span className="font-bold text-xs text-white uppercase">
                      RETIRADA DO KIT
                    </span>
                    <div className="text-[10px] text-slate-300 flex flex-col items-center gap-0.5">
                      <span className="flex items-center gap-1">
                        <Calendar className="w-3 h-3 text-urb-primary" /> 11/07 e 12/07
                      </span>
                      <span className="flex items-center gap-1 text-[9px] text-slate-400">
                        <MapPin className="w-3 h-3 text-urb-primary" /> Praça do Barão - Macapá
                      </span>
                    </div>
                    <Button variant="secondary" size="sm" className="py-1 text-[10px] w-full mt-1">
                      Ver detalhes
                    </Button>
                  </div>
                </div>

                {/* Step 6 */}
                <div className="flex flex-col items-center text-center gap-3 p-2">
                  <div className="flex flex-col items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-urb-primary/10 border border-urb-primary/40 text-urb-primary font-black text-sm flex items-center justify-center">
                      6
                    </div>
                    <div>
                      <h4 className="text-white font-bold text-xs m-0">
                        BOM TREINO!
                      </h4>
                      <span className="text-[10px] text-slate-400 block mt-0.5">
                        Prepare-se, hidrate-se e vá com tudo!
                      </span>
                    </div>
                  </div>
                  <div className="bg-slate-950/80 border border-slate-800 rounded-xl p-3 flex flex-col items-center justify-center text-center gap-2 py-4 w-full">
                    <div className="w-9 h-9 rounded-full flex items-center justify-center bg-slate-900 border border-slate-700">
                      <Compass className="w-5 h-5 text-urb-primary" />
                    </div>
                    <span className="font-black text-xs text-urb-primary tracking-wider">
                      BOM TREINO!
                    </span>
                  </div>
                </div>
              </div>

              {/* Essential Sidebar ("O ESSENCIAL PARA O ATLETA") */}
              <div className="lg:col-span-4">
                <div className="bg-urb-card border border-urb-border rounded-2xl p-6 flex flex-col gap-5">
                  <div className="flex items-center justify-center gap-2 pb-3 border-b border-urb-border">
                    <Star className="w-4 h-4 text-urb-primary fill-urb-primary" />
                    <h3 className="text-white font-extrabold text-sm m-0 tracking-wide text-center">
                      O ESSENCIAL PARA O ATLETA
                    </h3>
                  </div>

                  <div className="flex flex-col gap-3.5">
                    {[
                      { icon: Zap, title: "Inscrições", desc: "Processo simples para você garantir sua vaga." },
                      { icon: Shield, title: "Pagamentos", desc: "Diversas formas de pagamento com total segurança." },
                      { icon: Calendar, title: "Acompanhamento do evento", desc: "Fique por dentro de todas as informações e atualizações." },
                      { icon: ShoppingBag, title: "Retirada do kit", desc: "Data, local e orientações para retirar seu kit com facilidade." },
                      { icon: QrCode, title: "QR Code", desc: "Mais agilidade e praticidade na retirada do kit e na largada." },
                      { icon: MessageSquare, title: "Comunicação", desc: "Avisos importantes e novidades direto para você." },
                      { icon: CheckCircle2, title: "Praticidade", desc: "Tudo o que você precisa em um só lugar." },
                    ].map((item, idx) => {
                      const Icon = item.icon;
                      return (
                        <div key={idx} className="flex items-start gap-3">
                          <div className="w-7 h-7 rounded-lg bg-urb-primary/10 border border-urb-primary/30 flex items-center justify-center shrink-0 mt-0.5">
                            <Icon className="w-3.5 h-3.5 text-urb-primary" />
                          </div>
                          <div className="flex flex-col">
                            <span className="font-bold text-white text-xs">{item.title}</span>
                            <p className="text-[11px] text-slate-400 m-0 leading-relaxed">
                              {item.desc}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Athlete Dashboard Preview Section */}
        <section className="py-16 px-4 md:px-8 max-w-7xl mx-auto">
          <div className="flex flex-col items-center text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-black m-0 text-white">
              SUA ÁREA DE ATLETA{" "}
              <span className="text-urb-primary">EM UM SÓ LUGAR</span>
            </h2>
            <p className="text-sm text-slate-400 mt-2 m-0 max-w-lg">
              Acompanhe suas inscrições, pagamentos, eventos e QR Code com total
              praticidade.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Card 1: Minhas Inscrições */}
            <div className="bg-urb-card/70 border border-urb-border rounded-2xl p-5 flex flex-col items-center text-center gap-3">
              <div className="flex items-center justify-center gap-2 border-b border-urb-border pb-2.5 w-full">
                <List className="w-4 h-4 text-urb-primary" />
                <h4 className="text-white font-bold text-xs uppercase m-0">
                  MINHAS INSCRIÇÕES
                </h4>
              </div>
              <div className="bg-slate-950/80 p-3.5 rounded-xl border border-slate-800 flex flex-col items-center text-center gap-2 w-full">
                <span className="font-black text-xs text-urb-primary">
                  URB NIGHT RUN
                </span>
                <span className="text-[11px] text-slate-300">Macapá - Amapá</span>
                <div className="flex justify-between items-center text-[10px] text-slate-400 mt-1 w-full">
                  <span>10K</span>
                  <span>12/07/2025</span>
                </div>
                <div className="text-[10px] text-slate-400">
                  Categoria: Geral Masculino
                </div>
                <div className="mt-1">
                  <span className="text-[9px] px-2 py-0.5 rounded-full bg-emerald-950/80 text-urb-primary border border-emerald-800 inline-block font-semibold">
                    Inscrição confirmada
                  </span>
                </div>
              </div>
              <Button variant="secondary" size="sm" className="mt-auto w-full text-xs">
                Ver detalhes
              </Button>
            </div>

            {/* Card 2: Pagamentos */}
            <div className="bg-urb-card/70 border border-urb-border rounded-2xl p-5 flex flex-col items-center text-center gap-3">
              <div className="flex items-center justify-center gap-2 border-b border-urb-border pb-2.5 w-full">
                <Wallet className="w-4 h-4 text-urb-primary" />
                <h4 className="text-white font-bold text-xs uppercase m-0">
                  PAGAMENTOS
                </h4>
              </div>
              <div className="flex flex-col gap-2 bg-slate-950/80 p-3.5 rounded-xl border border-slate-800 w-full text-xs">
                <div className="flex justify-between items-center">
                  <span className="text-[11px] text-emerald-400 font-semibold flex items-center gap-1">
                    <CheckCircle2 className="w-3 h-3 text-urb-primary" /> Confirmado
                  </span>
                  <span className="font-bold text-white">R$ 159,90</span>
                </div>
                <div className="flex justify-between text-[10px] text-slate-400">
                  <span>Pix</span>
                  <span>08/05/2025 - 10:32</span>
                </div>
                <hr className="border-t border-slate-800 my-1 w-full" />
                <div className="flex justify-between font-bold">
                  <span className="text-slate-300">Total pago</span>
                  <span className="text-urb-primary font-black">R$ 159,90</span>
                </div>
              </div>
              <span className="text-xs text-urb-primary hover:underline cursor-pointer text-center mt-auto">
                Ver todos os pagamentos
              </span>
            </div>

            {/* Card 3: Próximo Evento */}
            <div className="bg-urb-card/70 border border-urb-border rounded-2xl p-5 flex flex-col items-center text-center gap-3">
              <div className="flex items-center justify-center gap-2 border-b border-urb-border pb-2.5 w-full">
                <Calendar className="w-4 h-4 text-urb-primary" />
                <h4 className="text-white font-bold text-xs uppercase m-0">
                  PRÓXIMO EVENTO
                </h4>
              </div>
              <div className="bg-slate-950/80 p-3.5 rounded-xl border border-slate-800 flex gap-3 items-center w-full">
                <div className="bg-emerald-950/80 border border-emerald-800/60 rounded-lg p-2 text-center shrink-0">
                  <span className="text-[9px] text-urb-primary uppercase block font-black">
                    JUL
                  </span>
                  <span className="text-lg font-black text-white block">12</span>
                </div>
                <div className="flex flex-col gap-0.5 text-left">
                  <span className="font-bold text-xs text-white">
                    URB NIGHT RUN 10K
                  </span>
                  <span className="text-[10px] text-slate-400 flex items-center gap-1">
                    <Clock className="w-2.5 h-2.5 text-urb-primary" /> 12 de julho de 2025
                  </span>
                  <span className="text-[10px] text-slate-400 flex items-center gap-1">
                    <MapPin className="w-2.5 h-2.5 text-urb-primary" /> Macapá - Amapá
                  </span>
                </div>
              </div>
              <Button variant="secondary" size="sm" className="mt-auto w-full text-xs">
                Ver informações
              </Button>
            </div>

            {/* Card 4: Retirada do Kit */}
            <div className="bg-urb-card/70 border border-urb-border rounded-2xl p-5 flex flex-col items-center text-center gap-3">
              <div className="flex items-center justify-center gap-2 border-b border-urb-border pb-2.5 w-full">
                <ShoppingBag className="w-4 h-4 text-urb-primary" />
                <h4 className="text-white font-bold text-xs uppercase m-0">
                  RETIRADA DO KIT
                </h4>
              </div>
              <div className="bg-slate-950/80 p-3.5 rounded-xl border border-slate-800 flex flex-col gap-2 text-xs w-full">
                <div className="flex justify-between">
                  <span className="text-slate-400">Local</span>
                  <span className="text-white font-medium text-right text-[11px]">
                    Praça do Barão
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-400">Data</span>
                  <span className="text-white font-medium text-[11px]">11/07 e 12/07</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-400">Horário</span>
                  <span className="text-white font-medium text-[11px]">08h às 20h</span>
                </div>
              </div>
              <Button
                variant="primary"
                size="sm"
                className="mt-auto w-full text-xs font-bold uppercase flex items-center justify-center gap-1.5"
              >
                <QrCode className="w-3.5 h-3.5" />
                QR Code retirada
              </Button>
            </div>
          </div>
        </section>

        {/* Bottom CTA Banner */}
        <section className="py-8 px-4 md:px-8 max-w-5xl mx-auto my-8">
          <div className="bg-gradient-to-r from-slate-900 via-urb-card to-slate-900 border border-urb-border rounded-3xl p-8 md:p-12 flex flex-col items-center text-center justify-center gap-6 shadow-2xl">
            <div className="w-14 h-14 rounded-full flex items-center justify-center bg-urb-primary/10 border-2 border-urb-primary shrink-0">
              <Zap className="w-7 h-7 text-urb-primary" />
            </div>
            <div className="flex flex-col gap-2 max-w-xl">
              <h3 className="text-2xl md:text-3xl font-black text-white m-0">
                DESCUBRA SUA PRÓXIMA CORRIDA
              </h3>
              <p className="text-slate-300 text-sm leading-relaxed m-0">
                Novos desafios, novas conquistas. O próximo passo é seu.
              </p>
            </div>

            <Link to="/" className="no-underline">
              <Button
                variant="primary"
                size="lg"
                className="font-black text-sm uppercase px-8 py-3.5 tracking-wider shadow-lg flex items-center gap-2"
              >
                Explorar provas
                <ArrowRight className="w-4 h-4 ml-1" />
              </Button>
            </Link>
          </div>
        </section>
      </main>

      <LandingFooter />

      {/* Botão Flutuante do WhatsApp */}
      <WhatsAppButton />
    </div>
  );
}

export default ParaAtletas;
